import React from 'react'

import {
  IProps as ITestimonialMiniCard,
  TestimonialMiniCard,
} from 'marketing-site/src/library/elements/TestimonialMiniCard'
import { ITestimonialMiniCard as IContentfulTestimonialMiniCard } from 'marketing-site/@types/generated/contentful'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { transformImage } from '../elements/ContentfulImage'

export const ContentfulTestimonialMiniCard = (
  props: IContentfulTestimonialMiniCard,
): React.ReactElement => {
  return <TestimonialMiniCard {...transformTestimonialMiniCard(props)} />
}

export function transformTestimonialMiniCard({
  sys,
  fields,
}: IContentfulTestimonialMiniCard): ITestimonialMiniCard {
  return {
    ...fields,
    contentType: sys.contentType.sys.id,
    portraitImgRef: transformImage(fields.portraitImgRef),
    companyLogo: fields.companyLogo && fields.companyLogo.fields.file.url,
    headline: fields.headline ? documentToHtmlString(fields.headline) : undefined,
    sanitizedHeadline: fields.headline
      ? documentToHtmlString(fields.headline)
          .replace(/(<([^>]+)>)/gi, '')
          .trim()
      : undefined,
  }
}
